import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const termsSections = [
    {
        id: 'agreement',
        title: '1. Agreement to Terms',
        content: (
            <p>By accessing or using Codemine ("Service", "we", "us"), you agree to be bound by these Terms & Conditions ("Terms"). These Terms affect your legal rights and obligations. If you do not agree to be bound by all of these Terms, do not access or use the Service.</p>
        )
    },
    {
        id: 'service-description',
        title: '2. Description of Service',
        content: (
            <>
                <p>Codemine provides a platform that utilizes generative artificial intelligence ("AI") to create and modify web application code ("Outputs") based on user-provided text prompts ("Inputs"). The Service includes code generation, live previews, hosting for paid subscribers ("Live Projects"), and related features.</p>
            </>
        )
    },
    {
        id: 'user-responsibilities',
        title: '3. User Accounts & Responsibilities',
        content: (
            <>
                <p><strong>a. Eligibility:</strong> You must be at least 13 years of age to use the Service.</p>
                <p><strong>b. Account Security:</strong> You are responsible for safeguarding your account, including your password, and for any activities or actions under your account. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</p>
                <p><strong>c. Acceptable Use:</strong> You agree not to use the Service to generate, host, or distribute any content that is unlawful, harmful, defamatory, infringing on intellectual property rights, or contains malicious code (e.g., viruses, malware). You will not attempt to reverse engineer, disrupt, or gain unauthorized access to the Service.</p>
            </>
        )
    },
    {
        id: 'ai-outputs',
        title: '4. AI-Generated Content (Outputs)',
        content: (
            <>
                <p><strong>a. No Guarantees:</strong> The AI-generated Outputs are provided on an "as is" and "as available" basis. Due to the nature of machine learning, Outputs may contain errors, bugs, security vulnerabilities, or inaccuracies. Codemine does not guarantee that the Outputs will be accurate, reliable, secure, or fit for any particular purpose.</p>
                <p><strong>b. User Responsibility for Outputs:</strong> YOU ARE SOLELY RESPONSIBLE FOR REVIEWING, TESTING, AND VALIDATING ALL OUTPUTS BEFORE ANY USE, ESPECIALLY IN A PRODUCTION ENVIRONMENT. You assume all risks associated with the use of Outputs, including but not limited to data loss, system failure, or business interruption.</p>
            </>
        )
    },
    {
        id: 'ip-rights',
        title: '5. Intellectual Property Rights',
        content: (
            <>
                <p><strong>a. Our Service:</strong> We and our licensors retain all right, title, and interest in and to the Codemine Service and its underlying technology, including all related intellectual property rights.</p>
                <p><strong>b. Your Inputs:</strong> You retain all rights to the text prompts and content you provide to the Service.</p>
                <p><strong>c. Ownership of Outputs:</strong> Subject to your compliance with these Terms, Codemine grants you full ownership of the code generated specifically for you. You are free to use, modify, and deploy it for personal or commercial purposes.</p>
            </>
        )
    },
    {
        id: 'payments',
        title: '6. Subscriptions, Payments, and Cancellation',
        content: (
            <>
                <p>Our policies regarding subscriptions, credits, billing, and the effects of cancellation are detailed on our Pricing page and are incorporated herein by reference. Upon cancellation of a paid plan, any Live Projects hosted by Codemine will be taken offline, and associated backend services will be deactivated.</p>
            </>
        )
    },
    {
        id: 'liability',
        title: '7. Limitation of Liability',
        content: (
            <p>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL CODEMINE, ITS AFFILIATES, AGENTS, DIRECTORS, OR EMPLOYEES, BE LIABLE FOR ANY INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE LOSSES, THAT RESULT FROM THE USE OF, OR INABILITY TO USE, THIS SERVICE OR ANY OUTPUTS. OUR TOTAL AGGREGATE LIABILITY FOR ALL CLAIMS RELATING TO THE SERVICE SHALL NOT EXCEED THE GREATER OF ONE HUNDRED U.S. DOLLARS ($100) OR THE AMOUNTS PAID BY YOU TO US FOR THE PAST THREE MONTHS OF THE SERVICE IN QUESTION.</p>
        )
    },
    {
        id: 'indemnification',
        title: '8. Indemnification',
        content: (
            <p>You agree to defend, indemnify, and hold harmless Codemine and its employees, and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Service, or b) your use of any Outputs generated by the Service.</p>
        )
    },
    {
        id: 'governing-law',
        title: '9. Governing Law',
        content: (
            <p>These Terms shall be governed by the laws of Pakistan, without regard to its conflict of law provisions.</p>
        )
    },
    {
        id: 'changes',
        title: '10. Changes to Terms',
        content: (
            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of material changes. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.</p>
        )
    },
];

export default function TermsPage() {
    return (
        <LegalPageLayout
            pageTitle="Terms & Conditions"
            sections={termsSections}
        />
    );
}